/* Copyright (c) 2017 Backpack Health LLC */

/* eslint-disable no-underscore-dangle */
/* global window */

import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import mixpanelMiddleware from './middleware/mixpanelMiddleware';

import rootReducer from './reducers_authorizedApp';

//  default state is defined with the reducers
const defaultState = {};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  defaultState,
  composeEnhancers(
    applyMiddleware(thunkMiddleware, mixpanelMiddleware)
  )
);

export default store;
